module.exports = __webpack_public_path__ + "img/Character Nickname Screen.70687618.jpg";